import { useEffect, useState } from "react"
import useApiResource from "./use_api_resource"

const useApiRecord = ({ id = null, path, app = "registrations", data = {}, singular = false }) => {
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState([])
  const resource = useApiResource({ path, data, app, singular })
  const [record, setRecord] = useState(null)
  const [nonce, setNonce] = useState(null)
  const [response, setResponse] = useState(null)

  useEffect(() => {
    if (response === null) return
    const { requestNonce, data } = response

    if (requestNonce === nonce) {
      setRecord(data)
    }
  }, [response?.requestNonce])

  const apiRequest = request => {
    const requestNonce = new Date().getTime()

    setNonce(requestNonce)
    setErrors([])
    setLoading(true)

    return request(requestNonce)
      .then(response => {
        setResponse({ ...response, requestNonce })
        return response
      })
      .catch(exception => {
        setErrors(exception?.errors || [{ detail: exception.toString() }])
        throw exception
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    return fetch()
  }, [id, singular])

  const create = (attributes, data = {}) => apiRequest(() => resource.create(attributes, data))

  const update = (attributes, data = {}) => {
    if (!record) return
    return apiRequest(() => resource.update(record.id, attributes, data))
  }

  const destroy = () => {
    if (!record) return
    const recordId = record.id
    setRecord(null)
    return apiRequest(() => resource.destroy(recordId))
  }

  const fetch = () => {
    if (!id && !singular) return
    return apiRequest(() => resource.find(id, data))
  }

  return {
    loading,
    errors,
    resource: { ...resource, create },
    record: record ? { ...record, update, destroy, fetch } : null,
    setRecord
  }
}

export default useApiRecord
